import React, { useCallback } from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import { ChevronLeft, ChevronRight, ExternalLink } from 'lucide-react';
import { workExamples } from '../mock/data';

const WorkCarousel = () => {
  const [emblaRef, emblaApi] = useEmblaCarousel({ 
    loop: true, 
    align: 'start',
    skipSnaps: false
  });

  const scrollPrev = useCallback(() => {
    if (emblaApi) emblaApi.scrollPrev();
  }, [emblaApi]);

  const scrollNext = useCallback(() => {
    if (emblaApi) emblaApi.scrollNext();
  }, [emblaApi]);

  return (
    <div className="relative">
      <div className="overflow-hidden" ref={emblaRef}>
        <div className="flex gap-8">
          {workExamples.map((work) => (
            <div key={work.id} className="flex-[0_0_100%] md:flex-[0_0_45%] lg:flex-[0_0_32%] min-w-0">
              <div className="bg-white bg-opacity-5 border border-white border-opacity-25 overflow-hidden transition-all duration-400 hover:border-[#00FFD1] hover:border-opacity-50 group">
                <div className="aspect-[4/3] overflow-hidden bg-white bg-opacity-10">
                  <img 
                    src={work.image} 
                    alt={work.name}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="p-6 space-y-3">
                  <h3 className="text-xl font-semibold text-white">{work.name}</h3>
                  <p className="text-white text-opacity-85 leading-relaxed">{work.description}</p>
                  <a 
                    href={work.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 text-[#00FFD1] hover:text-white transition-colors duration-300 text-lg font-medium"
                  >
                    Visit site
                    <ExternalLink size={18} />
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Navigation buttons */}
      <div className="flex justify-center gap-4 mt-8">
        <button 
          onClick={scrollPrev}
          className="bg-white bg-opacity-10 hover:bg-[#00FFD1] hover:text-black text-white p-4 transition-all duration-400 backdrop-blur-sm"
          aria-label="Previous"
        >
          <ChevronLeft size={24} />
        </button>
        <button 
          onClick={scrollNext}
          className="bg-white bg-opacity-10 hover:bg-[#00FFD1] hover:text-black text-white p-4 transition-all duration-400 backdrop-blur-sm"
          aria-label="Next"
        >
          <ChevronRight size={24} />
        </button>
      </div>
    </div>
  );
};

export default WorkCarousel;